import {SessionRepository} from "./session.repository";
import {SessionRepositoryV2} from "./session.repository.v2";

export type {SessionRepository} from "./session.repository";
export {SessionRepositoryV2} from "./session.repository.v2";

/**
 * Creates the SessionRepository.
 *
 * @example
 * const repository = createSessionRepository();
 * const session = await repository.getById(123);
 */
export const createSessionRepository = (): SessionRepository => {
  return new SessionRepositoryV2();
};
